module.exports = __webpack_public_path__ + "static/media/BadgeTemplates-84.054b685e.svg";